import { Badge, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { SourceItem } from '../types';
import { ResourceType } from '@app/types/blackroom-api';
import ResourceIcon from '@features/Resource/ResourceIcon';
import * as classes from './styles/index.css';

interface SourcesBarProps {
  sources: SourceItem[];
  onSourceClick: (source: SourceItem) => void;
}

function SourcesBar({ sources, onSourceClick }: SourcesBarProps) {
  const { t } = useTranslation();

  if (sources.length === 0) return null;

  return (
    <Stack gap={4} pb="sm">
      <Text size="xs" fw={500} c="gray.5">
        {t('AIAssistant:Chat.sources.title')}
      </Text>
      <Group
        gap={6}
        wrap="nowrap"
        className={classes.container}
        style={{ overflowX: 'auto' }}
      >
        {sources.map((source) => (
          <UnstyledButton
            key={source.resourceId}
            className={classes.card}
            onClick={() => onSourceClick(source)}
            py={6}
            px="xs"
            style={{
              borderRadius: 'var(--mantine-radius-sm)',
              border: '1px solid var(--mantine-color-gray-3)',
              flexShrink: 0,
              maxWidth: 220,
            }}
          >
            <Group gap={6} wrap="nowrap">
              <ResourceIcon
                resource={{
                  type: ResourceType.File,
                  mimeType: source.resourceMimeType ?? null,
                }}
                size={14}
                withColor
                style={{ flexShrink: 0 }}
              />
              <Text size="xs" fw={500} c="gray.7" truncate>
                {source.resourceName}
              </Text>
              {source.excerpts.length > 0 && (
                <Badge
                  size="xs"
                  variant="light"
                  color="gray"
                  circle={source.excerpts.length < 10}
                  style={{ flexShrink: 0 }}
                >
                  {source.excerpts.length}
                </Badge>
              )}
            </Group>
          </UnstyledButton>
        ))}
      </Group>
    </Stack>
  );
}

export default SourcesBar;
